/**
 * Shared illustrated "Day / Night" HUD control.
 * The artwork already contains frame, sun/moon icon, parchment, and label text.
 */

export const DAY_NIGHT_BUTTON_SRC = `${import.meta.env.BASE_URL}art/ui/day-night.png`;

/**
 * Image-as-button — no chrome, text, or icons beyond the artwork.
 * Click handler is supplied by the host (toggles yard time of day).
 */
export function createDayNightButton(options: {
  onActivate: () => void;
}): HTMLButtonElement {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'wp-day-night-btn';
  button.setAttribute('aria-label', 'Day / Night');

  const img = document.createElement('img');
  img.src = DAY_NIGHT_BUTTON_SRC;
  img.alt = '';
  img.decoding = 'async';
  img.draggable = false;
  img.setAttribute('aria-hidden', 'true');
  button.append(img);

  button.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    options.onActivate();
  });

  return button;
}
